export type BreakpointSize = "xs" | "sm" | "md" | "lg" | "xl";

export const getResponsiveBreakpoint = (): BreakpointSize => {
  const width = window.innerWidth;

  if (width < 600) return "xs";
  if (width < 900) return "sm";
  if (width < 1200) return "md";
  if (width < 1536) return "lg";
  return "xl";
};
